import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { Message } from 'element-ui';
import store from '../store';

Vue.use(VueRouter);

// 解决多次点击同个路由报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 路由拦截
router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login' && to.path !== '/replace' && to.path !== '/transfer' && to.path !== '/verity') {
    if (!sessionStorage.getItem('token')) {
      // Message.error("用户信息失效，请重新登录");
      // next('/login');
      next('/transfer');
      // if (process.env.VUE_APP_ENV == 'development') {
      //   // 本地环境
      //   next('/transfer');
      // } else if (process.env.VUE_APP_ENV == 'stage') {
      //   // 测试环境
      //   window.location.href = 'http://10.5.4.236:3605/index';
      // } else if (process.env.VUE_APP_ENV == 'production-h5') {
      //   // 线上安徽信创环境
      //   window.location.href = 'http://ahsjn.ijgsw.com:50029/index';
      // }
      return;
    } else {
      // let baseLocatioin = 'https://www.izkts.cn';
      // if (window.__wxjs_is_wkwebview) {
      //   if (window.entryUrl == ''||window.entryUrl == undefined) {
      //     let url = baseLocatioin + encodeURIComponent(to.fullPath);
      //     window.entryUrl = url;
      //   }
      // } else {
      //   window.entryUrl = baseLocatioin + to.fullPath;
      // }
      // sessionStorage.setItem('wxsdkUrl', window.entryUrl);
    }

    // 重新打开的
    // if (sessionStorage.getItem('token') && !store.state.app.userInfo) {
    //   const userInfoCache = JSON.parse(sessionStorage.getItem('userInfo'));
    //   const menuToken = JSON.parse(sessionStorage.getItem('menu'));
    //   if (userInfoCache.userId && menuToken.length) {
    //     store.dispatch('app/updateLoginInfo', {
    //       userInfo: userInfoCache,
    //       menu: menuToken
    //     });
    //   } else {
    //     sessionStorage.removeItem('token');
    //     next('/login');
    //     Message.error('用户信息失效，请重新登录');
    //     return;
    //   }
    // }
  } else if (to.path == '/login' || to.path == '/verity' || to.path == '/transfer' || to.path == '/replace') {
    next();
    // if (process.env.VUE_APP_ENV == 'development') {
    //   // 本地环境
    //   next();
    // } else if (process.env.VUE_APP_ENV == 'stage') {
    //   // 本地或测试环境
    //   window.location.href = 'http://10.5.4.236:3605/index';
    //   // next('http://10.5.4.236:3605/index');
    // } else if (process.env.VUE_APP_ENV == 'stage-dev') {
    //   // 本地或测试环境（192.168.0.55测试服务）
    //   window.location.href = 'http://112.26.65.87:3605/index';
    // } else if (process.env.VUE_APP_ENV == 'production') {
    //   // 线上华为云环境
    //   window.location.href = 'http://119.3.57.254:50029/index';
    // } else if (process.env.VUE_APP_ENV == 'production-ahxc') {
    //   // 线上安徽信创环境
    //   window.location.href = 'http://ahsjn.ijgsw.com:50029/index';
    // }
  }
  next();
});

export default router;
